import React from 'react';
import { Form as FinalForm } from 'react-final-form';
import { required } from '../../util/validators';
import { SecondaryButton, Form, FieldCheckbox, FieldTextInput } from '../../components';
import css from './index.css';

const EditForm = ({ onSubmit: parentHandleSubmit, initialValues = {}, action }) => (
    <FinalForm
        onSubmit={parentHandleSubmit}
        initialValues={initialValues}
        render={fieldRenderProps => {
            const { handleSubmit, values, form } = fieldRenderProps;
            const { visibility, countries, logo, link, description } = values || {};

            const disabled =
                !visibility ||
                visibility.length === 0 ||
                !countries ||
                countries.length === 0 ||
                !logo ||
                !link ||
                !description;

            return (
                <Form onSubmit={handleSubmit} className={css.form}>
                    <div>
                        <p>Visibility *</p>
                        <FieldCheckbox
                            type="checkbox"
                            id="loggedIn"
                            name="visibility"
                            label="Logged In"
                            value="loggedIn"
                            form={form}
                        />
                        <FieldCheckbox
                            type="checkbox"
                            id="loggedOut"
                            name="visibility"
                            label="Logged Out"
                            value="loggedOut"
                            form={form}
                        />
                    </div>
                    <div>
                        <p>Countries *</p>
                        <FieldCheckbox
                            type="checkbox"
                            id="CH"
                            name="countries"
                            label="Schweiz"
                            value="CH"
                            form={form}
                        />
                        <FieldCheckbox
                            type="checkbox"
                            id="DE"
                            name="countries"
                            label="Deutschland"
                            value="DE"
                            form={form}
                        />
                    </div>
                    <div>
                        <p>User type</p>
                        <FieldCheckbox
                            type="checkbox"
                            id="horseowner"
                            name="userType"
                            label="Horseowner"
                            value="horseowner"
                            form={form}
                        />
                        <FieldCheckbox
                            type="checkbox"
                            id="rider"
                            name="userType"
                            label="Rider"
                            value="rider"
                            form={form}
                        />
                    </div>
                    <div>
                        <p>Icon *</p>
                        <FieldTextInput
                            type="text"
                            id="logo"
                            name="logo"
                            placeholder="https://horsedeal.imgix.net/static/icons/android-chrome-192x192.png"
                            validate={required('This field is required')}
                        />
                    </div>

                    <div>
                        <p>Description *</p>
                        <FieldTextInput
                            type="text"
                            id="description"
                            name="description"
                            placeholder="E.g. Lorem ipsum"
                            validate={required('This field is required')}
                        />
                    </div>

                    <div>
                        <p>Link *</p>
                        <FieldTextInput
                            type="text"
                            id="link"
                            name="link"
                            placeholder="E.g. https://www.horsedeal.com"
                            validate={required('This field is required')}
                        />
                    </div>

                    <footer>
                        <SecondaryButton disabled={disabled} type="submit">
                            admin::{action}
                        </SecondaryButton>
                    </footer>
                </Form>
            );
        }}
    />
);

export default EditForm;
